import { CxAlertsService } from '@app/libs/components/cx-alerts/cx-alerts.service';
import { ConnectionService, ConnectionState } from 'ng-connection-service';
import { CentroDeAyudaService } from './centro-de-ayuda.service';
import { FormBuilder, FormGroup, Validators, FormControl, NgForm } from '@angular/forms';
import { HttpClient } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';


@Component({
  selector: 'app-centro-de-ayuda',
  templateUrl: './centro-de-ayuda.component.html',
  styleUrls: ['./centro-de-ayuda.component.scss']
})
export class CentroDeAyudaComponent implements OnInit {

  FormData: FormGroup;

  public helpItemList: any[] = [];
  public firstItem: any;
  public lastItem: any;
  public isConnected: boolean = true;
  tooltipIsVisible: boolean;
  submitted: boolean;
  msgOffline: boolean;
  constructor(
    private centroDeAyuda: CentroDeAyudaService,
    private http: HttpClient,
    private builder: FormBuilder,
    private alertService: CxAlertsService,
    private connectionService: ConnectionService
  ) {
    this.helpItemList = [
      { // pregunta 1
        body: 'En la pantalla principal del menú “Exámenes”, al seleccionar la pestaña <strong>“Periódicos”</strong> o <strong>“Reconfirmación”</strong> se visualizarán todos los exámenes periódicos pendientes de cargar por parte del prestador',
        title: '¿Cómo veo los estudios periódicos / reconfirmación pendientes de carga?'
      },
      { // pregunta 2
        title: '¿Qué se necesita para poder cargar exámenes sin conexión a Internet - Offline?',
        body: 'Se necesita ingresar al sistema teniendo conexión a Internet para que se carguen en el dispositivo los exámenes pendientes por parte del prestador. Una vez realizada esta acción, si se pierde la conexión a Internet - Offline podrá ingresar al dispositivo y proceder a la carga de estos exámenes.'
      },
      { // pregunta 3
        title: '¿Cómo veo los exámenes periódicos y de reconfirmación cargados sin conexión - Offline y pendientes de envío?',
        body: 'En la pantalla principal del menú “Exámenes”, al seleccionar la pestaña <strong>“Por Enviar”</strong> se visualizarán todos los exámenes cargados por parte del prestador estando sin conexión a Internet (Offline), y una vez tenga conexión estos se sincronizarán automáticamente.'
      },
      { // pregunta 4
        title: '¿Cómo sé por qué un exámen cargado sin conexión a internet no se sincronizó?',
        body: 'En la pestaña <strong>“Por Enviar”</strong>, en cada examen saldrá la etiqueta “Error de envió” y al posicionarse sobre el icono se mostrará el motivo por el cual no se sincronizó el examen. De igual manera se podrá eliminar el examen de la pestaña con el icono de eliminación en la parte inferior derecha de su pantalla.'
      },
      { // pregunta 5
        title: '¿Cómo veo la cantidad de exámenes periódicos y de reconfirmación pendientes de carga?',
        body: 'En cada pestaña ya sea “Periódicos o “Reconfirmación”, se visualiza la cantidad de exámenes pendientes de carga por parte del prestador.'
      },
      { // pregunta 6
        title: '¿Cómo veo la vigencia de un examen?',
        body: `
        <div style="display:block !important">Dentro de cada examen se encuentra el campo “Vigencias en días hábiles” y la indicación en el color respectivo según lo definido por Provincia ART.</div>
        <br/>
        <span style="display:flex !important; justify-content: center !important; width: 100%;">
          <div style="display:flex !important; justify-content: space-between !important; width: 100%; min-width: 500px; max-width: 560px;">
              <span style="display:block !important; width: 250px;">
                  <div style="margin-bottom: 8px !important;">
                      <strong>Para Periódicos:</strong>
                  </div>
                  <div style="display:flex !important; justify-content: space-between !important;">
                      <span>Verde:</span><span style="text-align: left; min-width: 120px;">Menor a 30 días</span>
                  </div>
                  <div style="display:flex !important; justify-content: space-between !important;">
                      <span>Amarillo:</span><span style="text-align: left; min-width: 120px;">De 31 a 45 días</span>
                  </div>
                  <div style="display:flex !important; justify-content: space-between !important;">
                      <span>Naranja:</span><span style="text-align: left; min-width: 120px;">De 46 a 90 días</span>
                  </div>
                  <div style="display:flex !important; justify-content: space-between !important;">
                      <span>Rojo:</span><span style="text-align: left; min-width: 120px;">Mayor a 91 días</span>
                  </div>
              </span>
              <span style="display:block !important; width: 250px;">
                  <div style="margin-bottom: 8px !important;">
                      <strong>Para Reconfirmación:</strong>
                  </div>
                  <div style="display:flex !important; justify-content: space-between !important;">
                      <span>Verde:</span><span style="text-align: left; min-width: 120px;">Menor a 12 días</span>
                  </div>
                  <div style="display:flex !important; justify-content: space-between !important;">
                      <span>Amarillo:</span><span style="text-align: left; min-width: 120px;">De 13 a 20 días</span>
                  </div>
                  <div style="display:flex !important; justify-content: space-between !important;">
                      <span>Naranja:</span><span style="text-align: left; min-width: 120px;">De 21 a 30 días</span>
                  </div>
                  <div style="display:flex !important; justify-content: space-between !important;">
                      <span>Rojo:</span><span style="text-align: left; min-width: 120px;">Mayor a 31 días</span>
                  </div>
              </span>
          </div>
        </span>`
      },
      { // pregunta 7
        title: '¿Cómo busco los exámenes según diferentes criterios?',
        body: `Al acceder a las solapas de Periódicos, Reconfirmación, Cargados y Por enviar se encuentra la opción de <strong>“Filtros”</strong> la cual despliega en la parte derecha la barra de filtros para configurar los criterios y buscar los exámenes según lo deseado. 
        <br><br>
        Se debe configurar los filtros que se deseen (n° de lote, dni, vigencia, estudio, etc.) y seleccionar la opción <strong>"Buscar"</strong> . Esta opción recupera todos los exámenes disponibles para su carga que cumplan con esos criterios.`
      },
      { // pregunta 8
        title: '¿Cómo puedo imprimir un examen?',
        body: 'Dentro de cada examen se encuentra la opción <strong>“Imprimir Examen”</strong>, al dar clic se visualiza el examen en (.pdf) para poder guardar o realizar la impresión desde el navegador.'
      },
      { // pregunta 9
        title: '¿Qué tipos de archivo, tamaño y cantidad se puede adjuntar en los exámenes?',
        body: `En cada examen que contenga la sección de “Archivos adjuntos” se puede:
        <br/>
        <ul>
          <li>Tipos de archivos permitidos       (.jpg - .png - .bmp - .pdf)</li>
          <li>Tamaño de archivos permitidos      Hasta 5 Mb</li>
          <li>Cantidad de archivos permitidos    Hasta 5 archivos</li>
        </ul>`
      },
      { // pregunta 11
        title: '¿Cómo veo los exámenes que cargué?',
        body: `En la pantalla principal del menú “Exámenes”, al seleccionar la pestaña “Cargados” y la opción de “Filtros” en la cual podrá utilizar alguna de las opciones predeterminadas de búsqueda, se visualizarán los resultados de la búsqueda ingresada.
        <br><br>
        Se visualizará la opción de “Ver” y al ingresar podrá visualizar y/o imprimir el examen cargado.`
      },
      { // pregunta 12
        title: '¿Cómo modifico un examen cargado?',
        body: 'Al realizar la búsqueda en la pestaña “Cargados”, se visualizará la opción de “Editar” y al ingresar podrá modificar los campos del examen que se guardarán al guardarlo de nuevo.'
      },
      { // pregunta 13
        title: '¿Donde registro el presente o ausente del trabajador?',
        body: 'En las pestañas de “Periódicos o “Reconfirmación”, al lado del botón de carga del estudio se encuentra la opción para registrar Presente y Ausente del trabajador.'
      },
      { // pregunta 14
        title: '¿Dónde cargo los datos de contacto de los operativos o lotes?',
        body: 'En la solapa <strong>"Agenda"</strong>, podrá filtrar, cargar y editar los datos de contacto para cada lote de exámenes.'
      },
      { // pregunta 15
        title: '¿Cómo se usa la opción Buscar en las bandejas de periódicos y reconfirmación?',
        body: `La opción <strong>"Buscar"</strong> que se encuentra en la barra de filtros en las bandejas de Periódicos y Reconfirmación se utiliza para filtrar los exámenes que se visualizan en cada una buscando por el texto que se ingrese. 
        <br><br>
        Se puede buscar por el texto de cualquiera de los campos de: nombre exámen, dni, nombre de trabajador, esop, vigencia, empresa, contrato y lote. En el caso de no encontrar los exámenes que se buscan se sugiere acceder a la pantalla de <strong>"Filtros"</strong> para buscarlos en todo el universo de exámenes del prestador.`
      }
    ];
    this.connectionService.monitor().subscribe(connected => {
      this.isConnected = connected.hasNetworkConnection;;
      if (this.isConnected) {
        this.FormData.enable();
      } else {
        this.FormData.disable();
      }
    });
  }
  get f(): any {
    return this.FormData.controls;
  }
  ngOnInit(): void {

    this.http.get<any[]>('https://jsonplaceholder.typicode.com/posts')
      .subscribe(fetchedPost => {
        fetchedPost.length = 5;

        // this.helpItemList.map(item => {
        //   item.opened = false;
        // });

        // this.helpItemList = [
        //   {
        //     body: 'Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry´s standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged.',
        //     title: '¿Cómo veo la vigencia de un examen?',
        //   },
        // ];
      });

    const isOnline = JSON.parse(localStorage.getItem('isStillOnline'));
    this.isConnected = isOnline;
    if (!isOnline) {
      this.FormData.disable();
    }
  }

  checkConnection(event): void {
    const isOnline = JSON.parse(localStorage.getItem('isStillOnline'));
    if (!isOnline) {
      this.msgOffline = true;
      this.scrollTop();
    }
  }

  mouseEnter(): void {
    this.tooltipIsVisible = true;
  }

  mouseLeave(): void {
    this.tooltipIsVisible = false;
  }
  scrollTop() {
    const scrollElem = document.querySelector('#moveTop') as any;
    window.scroll(0, scrollElem.offsetTop - 100);
  }
}
